import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const KazaDetay = () => {
  const { id } = useParams();
  const [kaza, setKaza] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchKaza = async () => {
      try {
        const ref = doc(db, "kazalar", id);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = snap.data();
          setKaza(data);
        }
      } catch (error) {
        console.error("⚠️ Veri alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchKaza();
  }, [id]);

  const formatDate = (ts) => {
    if (!ts) return "";
    const dateObj = ts.toDate ? ts.toDate() : new Date(ts);
    return dateObj.toLocaleDateString("tr-TR");
  };

  if (loading) return <div style={{ padding: 20 }}>Yükleniyor...</div>;
  if (!kaza) return <div style={{ padding: 20 }}>Kaza bilgisi bulunamadı.</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>{kaza.kazaBasligi || "Kaza Başlığı"}</h2>
      <p><strong>Tarih:</strong> {formatDate(kaza.tarih)}</p>
      <p><strong>Saat:</strong> {kaza.saat}</p>
      <p><strong>Plaka:</strong> {kaza.plaka}</p>
      <p><strong>Personel:</strong> {kaza.personel}</p>
      <p><strong>Açıklama:</strong> {kaza.aciklama}</p>

      <h3>📸 Fotoğraflar</h3>
      {Array.isArray(kaza.kazaFotoURL) && kaza.kazaFotoURL.length > 0 ? (
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          {kaza.kazaFotoURL.map((url, i) => (
            <img
              key={i}
              src={url}
              alt={`kaza-foto-${i}`}
              style={{ width: 200, height: 150, objectFit: "cover", borderRadius: 8 }}
            />
          ))}
        </div>
      ) : (
        <p>Fotoğraf bulunamadı.</p>
      )}

      {kaza.raporURL && (
        <div style={{ marginTop: 20 }}>
          <h3>📄 Kaza Raporu</h3>
          <a href={kaza.raporURL} target="_blank" rel="noopener noreferrer">
            PDF Raporu Görüntüle
          </a>
        </div>
      )}
    </div>
  );
};

export default KazaDetay;
